export const shirtColorPalette1 = `<rect width="40" height="40" rx="4" fill="#49A078"/>`;

export const shirtColorPalette2 = `<rect width="40" height="40" rx="4" fill="#9CC5A1"/>`;

export const shirtColorPalette3 = `<rect width="40" height="40" rx="4" fill="#ED6A5A"/>`;

export const shirtColorPalette4 = `<rect width="40" height="40" rx="4" fill="#BF4342"/>`;

export const shirtColorPalette5 = `<rect width="40" height="40" rx="4" fill="#F7A1C8"/>`;

export const shirtColorPalette6 = `<rect width="40" height="40" rx="4" fill="#2EC0F9"/>`;

export const shirtColorPalette7 = `<rect width="40" height="40" rx="4" fill="#C09BD8"/>`;

export const shirtColorPalette8 = `<rect width="40" height="40" rx="4" fill="#FFE570"/>`;
